<template>
  <!--
    作者：gmshop
    时间：2020-06-04
    描述：插件中心-积分商城-商品设置-添加商品-商品信息
  -->
  <div>
    <div class="common-form">商品信息</div>
    <el-form-item label="商品名称">
      <p class="fb">{{ form.product_name }}</p>
    </el-form-item>
    <el-form-item label="商品图片"><img :src="form.product_image" width="80" /></el-form-item>

    <el-form-item label="所属类目:" >
      <el-select v-model="form.cat_id" @change="changeType($event)" width="300">
        <el-option v-for="(item,index) in form.shopcatList" :key="index" :label="item.name" :value="item.cat_id"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  inject: ['form'],
  created() {

  },
  methods: {
    changeType(e) {
      this.form.cat_id = e;
      let shopcatList = this.form.shopcatList;
      let product_qualification_type = 0;
      shopcatList.forEach(item=>{
        if(item.cat_id==e){
          product_qualification_type = item.product_qualification_type;
        }
      });
      this.form.product_qualification_type = product_qualification_type;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ministore/product/part/Info.vue